import React from 'react';

const BrandLogo = ({ size = "md", className = "" }) => {
  const dimensions = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-12 h-12"
  };

  return (
    <div className={`relative ${dimensions[size]} ${className}`}>
      {/* The Prism Core */}
      <svg viewBox="0 0 100 100" className="w-full h-full drop-shadow-[0_0_8px_rgba(6,182,212,0.6)]">
        <defs>
          <linearGradient id="prism-grad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#06b6d4" />
            <stop offset="100%" stopColor="#0891b2" />
          </linearGradient>
        </defs>
        {/* Hexagon Base */}
        <path 
          d="M50 5 L90 27.5 L90 72.5 L50 95 L10 72.5 L10 27.5 Z" 
          fill="none" 
          stroke="url(#prism-grad)" 
          strokeWidth="2"
          className="opacity-40"
        />
        {/* Inner Refraction Lines */}
        <path 
          d="M50 5 L50 95 M10 27.5 L90 72.5 M90 27.5 L10 72.5" 
          stroke="#06b6d4" 
          strokeWidth="1"
          className="opacity-30"
        />
        {/* The Amber Focus Point */}
        <circle cx="50" cy="50" r="8" fill="#f59e0b" className="animate-pulse shadow-[0_0_15px_#f59e0b]" />
        <path d="M50 35 L50 42 M50 58 L50 65 M35 50 L42 50 M58 50 L65 50" stroke="#f59e0b" strokeWidth="2" />
      </svg>
    </div>
  );
};

export default BrandLogo;